import React from 'react';
import PropTypes from 'prop-types';
import useCanPermissions from './hooks/useCanPermissions';

const RouteWithProtect = ({ children, routePermissions }) => {
  const { isCan } = useCanPermissions();
  return (
    isCan(routePermissions)
      ? children : <p style={{ paddingTop: 80, textAlign: 'center' }}>Select a section from the menu.</p>
  );
};

RouteWithProtect.propTypes = {
  children: PropTypes.node.isRequired,
  routePermissions: PropTypes.shape({
    permission: PropTypes.string,
    adminMode: PropTypes.bool,
  }).isRequired,
};

export default RouteWithProtect;
